export const bot = {
  modal: {
    // The inbox is no longer WhatsApp-only: it merges WhatsApp, web concierge and OTA.
    title: "Casella dei messaggi",
    subtitle: "WhatsApp, concierge web e OTA in un unico posto",
  },

  channels: {
    all: "Tutti",
    whatsapp: "WhatsApp",
    web: "Web",
    ota: "OTA",
  },

  empty: {
    title: "Nessun nuovo messaggio",
    description: "I nuovi messaggi del bot appariranno qui quando arriveranno",
  },

  buttons: {
    markAll: "Segna tutti come letti",
    goToChat: "Configura AI Agent",
    archive: "Archivia conversazione",
  },

  actions: {
    replyWhatsApp: "Rispondi su WhatsApp",
  },

  time: {
    now: "Ora",
    minuteSuffix: "m",
    hourSuffix: "h",
    daySuffix: "g",
    today: "Oggi",
    yesterday: "Ieri",
  },

  questions: {
    searchPlaceholder: "Cerca domande...",
    answered: "Con risposta",
    noAnswer: "In sospeso",
    withImage: "Con immagine",
    empty: "Nessuna domanda trovata",
    confirmDelete: "Sei sicuro di voler eliminare questa domanda?",
  },

  answer: {
    assistantResponse: "Risposta dell'assistente",
    attachedImageOptional: "Immagine allegata (facoltativa)",
    uploadImage: "Carica immagine",
    clickToSelect: "Clicca per selezionare un'immagine",
    changeImage: "Cambia immagine",
    imagePreviewAlt: "Anteprima immagine",
    defaultImageName: "image.jpg",
  },

  phone: {
    online: "online",
    today: "Oggi",
    exampleQuestion: "Domanda di esempio",
    writeAnswerPlaceholder: "Scrivi una risposta per questa domanda...",
    writeMessagePlaceholder: "Scrivi un messaggio...",
    answerImageAlt: "Immagine della risposta",
    confirmDeleteImage: "Eliminare l'immagine?",
    imageDeletedSuccess: "Immagine eliminata con successo.",
    virtualAssistant: "Assistente virtuale",
  },

  search: {
    placeholder: "Cerca per nome, telefono o codice di prenotazione...",
    noResultsTitle: "Nessuna conversazione trovata",
    noResultsDescription:
      "Prova con un altro nome, numero di telefono o codice di prenotazione.",
  },

  archive: {
    title: "Archivia conversazione",
    message:
      "Se archivi questa conversazione, scomparirà da questo elenco. Potrai comunque accedervi dalla prenotazione collegata.",
    cancel: "Annulla",
    confirm: "Archivia",
  },
};

export default bot;
